import React from 'react';
import { UserIcon, PhoneIcon, CalendarIcon } from 'lucide-react';
interface PatientListProps {
  searchTerm: string;
  selectedPatientId: number | null;
  onSelectPatient: (id: number) => void;
}
const mockPatients = [{
  id: 1,
  name: 'John Doe',
  phone: '+1 (555) 123-4567',
  age: 45,
  lastVisit: '2024-01-10',
  status: 'Active'
}, {
  id: 2,
  name: 'Jane Smith',
  phone: '+1 (555) 234-5678',
  age: 32,
  lastVisit: '2024-01-12',
  status: 'Active'
}, {
  id: 3,
  name: 'Bob Wilson',
  phone: '+1 (555) 345-6789',
  age: 58,
  lastVisit: '2024-01-08',
  status: 'Active'
}, {
  id: 4,
  name: 'Alice Brown',
  phone: '+1 (555) 456-7890',
  age: 28,
  lastVisit: '2024-01-15',
  status: 'Active'
}, {
  id: 5,
  name: 'Charlie Davis',
  phone: '+1 (555) 567-8901',
  age: 41,
  lastVisit: '2023-12-20',
  status: 'Inactive'
}];
export function PatientList({
  searchTerm,
  selectedPatientId,
  onSelectPatient
}: PatientListProps) {
  const filteredPatients = mockPatients.filter(patient => patient.name.toLowerCase().includes(searchTerm.toLowerCase()) || patient.phone.includes(searchTerm));
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1322">
      <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-1323">
        <h3 className="font-semibold text-gray-900" data-id="element-1324">
          All Patients ({filteredPatients.length})
        </h3>
      </div>
      <div className="divide-y divide-gray-200 max-h-[calc(100vh-300px)] overflow-y-auto" data-id="element-1325">
        {filteredPatients.map(patient => <button key={patient.id} onClick={() => onSelectPatient(patient.id)} className={`w-full p-4 text-left hover:bg-gray-50 transition-colors ${selectedPatientId === patient.id ? 'bg-green-50 border-l-4 border-green-600' : ''}`} data-id="element-1326">
            <div className="flex items-start space-x-3" data-id="element-1327">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1328">
                <UserIcon className="w-5 h-5 text-green-600" data-id="element-1329" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-1330">
                <div className="flex items-center justify-between mb-1" data-id="element-1331">
                  <h4 className="font-semibold text-gray-900 truncate" data-id="element-1332">
                    {patient.name}
                  </h4>
                  <span className={`px-2 py-1 text-xs font-medium rounded-full ${patient.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-1333">
                    {patient.status}
                  </span>
                </div>
                <div className="flex items-center text-sm text-gray-600 mb-1" data-id="element-1334">
                  <PhoneIcon className="w-3 h-3 mr-1" data-id="element-1335" />
                  <span className="truncate" data-id="element-1336">{patient.phone}</span>
                </div>
                <div className="flex items-center text-xs text-gray-500" data-id="element-1337">
                  <CalendarIcon className="w-3 h-3 mr-1" data-id="element-1338" />
                  <span data-id="element-1339">Last visit: {patient.lastVisit}</span>
                </div>
              </div>
            </div>
          </button>)}
      </div>
    </div>;
}